export default {
  selectedNotification: {},
  isLoading: false,
  notificaciones: [],
  usuarios: [],
  availableListUser: false,
  selectedUserNotifications: null,
  isOpenModalSuscripcionMasiva: false,
  isOpenDetails: false,
  isOpenModalSuscribirTrabajadores: false,
  isOpenModalEliminarSuscripcion: false,
  typeUserRelationFilter: "INT",
  selectedOption: {
    icon: "new_releases", name: "Trabajadores Internos",
  },
  searchTextUser: null,
  searchTextDetailUser: null,
  listValidacionUsuarios: [],
};

